import type { Opt } from '@jet/environment/types/optional';
import type { StorageKey } from './StorageKeys';

export interface EmptyObject {}

export type SerializableValue =
    | string
    | number
    | boolean
    | SerializableObject
    | SerializableValue[]
    | EmptyObject;
export interface SerializableObject {
    [key: string]: SerializableValue;
}

export enum PersistenceScope {
    // Storage tied to the current user
    // Keyed by the user's DSID
    User = 'user',
    // Scoped tied to the current device
    Device = 'device',
}

export interface Persistence {
    getValueForKey(
        key: StorageKey,
        scope: PersistenceScope,
    ): Opt<SerializableValue>;
}

export function serializeDate(date: Date): string {
    return date.toJSON();
}

export function deserializeDate(dateSting: string): Opt<Date> {
    const date = new Date(dateSting);
    if (isNaN(date.getTime())) {
        return null;
    }

    return date;
}
